import { useLocalization } from '@/services/localizationService';
import { useRecoilValue } from 'recoil';
import settingsState from '@/stores/settingsStore';

type PaymentRatioProps = {
  price: string;
  className: string;
  hasIntroPrice: boolean;
  firstSpanClassName: string;
  isWebOnboarding?: boolean;
};

export default function PaymentRatio({
  price,
  className,
  firstSpanClassName,
  hasIntroPrice,
  isWebOnboarding = false,
}: PaymentRatioProps) {
  const { t, data } = useLocalization();
  const settings = useRecoilValue(settingsState);

  const [amount, period] = price.split('/');

  return (
    <>
      {hasIntroPrice && settings.values.compliantPriceEnabled ? (
        <p className="SB25 text-black">
          <span>{t(data.onboarding.daysIntro)}</span>
          <span className="mx-1">{t(data.common.then, null, 'lowercase')}</span>
          <span>
            {amount} <span className="lowercase">per</span> {period}
          </span>
        </p>
      ) : hasIntroPrice || isWebOnboarding ? (
        <div className="flex">
          <p className="SB25 text-gray-400 line-through ">{amount}</p>
          {hasIntroPrice && isWebOnboarding && (
            <p className="SB25 text-black ms-1">$0.99</p>
          )}
          {hasIntroPrice && !isWebOnboarding && (
            <p className="SB25 text-black ms-1">
              {t(data.onboarding.daysIntro)}
            </p>
          )}
          {!hasIntroPrice && isWebOnboarding && (
            <p className="SB25 text-black ms-1">$0</p>
          )}
        </div>
      ) : (
        price.split('/').map((text, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={i} className={i === 0 ? firstSpanClassName : className}>
            {i ? '/' : ''}
            {text}
          </span>
        ))
      )}
    </>
  );
}
